import { BdLocale } from './locale';

export function LocalDateResolver(
    $window
) {
    return BdLocale($window).formatDate;
}
LocalDateResolver.$inject = [
    '$window'
];
